import moment from 'moment';

const DAILY_PRICE = 'pricesDailyForm';
const DAILY_TIME_PRICE = 'pricesDailyScheduleForm';
const EQUAL_PRICE = 'pricesEqualForm';
const FIXED_PRICE = 'pricesFixedForm';
const FUTURE_PRICES = 'activityFuturePricesForm'

const getParticipants = (
  activity,
  bookActivityForm,
  setIsUpdatedParticipants,
  isUpdatedParticipants,
  currency,
  previousParticipants
) => {
  if (!activity) return;

  const selectedCurrency = currency || bookActivityForm.values.currency;
  let startingDate = bookActivityForm.values.startingDate;
  const multiDates = bookActivityForm.values.multiDates;
  const prices = activity[activity.pricesType];
  const pricesType = activity['pricesType'];
  const futurePriceForm = activity['futurePriceForm']
  const scheduleType = activity['scheduleType'];
  // const isMultiDates = !!multiDates;
  const participants = [];
  // const pricesEqual = activity[activity.pricesType];

  setIsUpdatedParticipants(!isUpdatedParticipants);

  if (!startingDate && multiDates) {
    startingDate = multiDates.startDate;
  }

  if (futurePriceForm === FUTURE_PRICES && startingDate) {
  const date = moment(startingDate);
  const futurePrices = activity[FUTURE_PRICES] || [];
  
  let hasMatchingFuturePrice = false;
  const uniqueParticipants = new Map();
  
  futurePrices.forEach(priceSet => {
    const priceStart = moment(priceSet.startDate);
    const priceEnd = moment(priceSet.endDate);
    
    const isMatching = date.isBetween(priceStart, priceEnd, 'days', '[]');
    
    if (isMatching) {
      hasMatchingFuturePrice = true;
      const priceValue = priceSet.prices[selectedCurrency];
      const participantKey = `${priceSet.participant}-${selectedCurrency}`;
      
      if (!uniqueParticipants.has(participantKey)) {
      uniqueParticipants.set(participantKey, true);  

      participants.push({
        id: `${priceSet.participant}-${selectedCurrency}-${priceValue}`,
        participant: priceSet.participant, 
        participants: 0,
        currency: selectedCurrency,
        currencyValue: priceValue,
        NOK: priceSet.prices.NOK || 0,
        EUR: priceSet.prices.EUR || 0,
        USD: priceSet.prices.USD || 0,
        ratePlanId: priceSet.ratePlanId,
        ratePlanTitle: priceSet.ratePlanTitle
      });
    }
  }
  });
  
  if (!hasMatchingFuturePrice) {
    // Use fallback pricing methods
    return _useFallbackPricing(
      activity,
      selectedCurrency,
      startingDate,
      scheduleType,
      previousParticipants,
      pricesType
    );
  }
  
  return _setPreviousParticipantValue(participants, previousParticipants);
}
  if (!startingDate && !multiDates) {
    if (!prices.categories) {
      _setFixedParticipant(
        prices,
        participants,
        selectedCurrency,
        previousParticipants
      );
      return participants;
    }
    _setParticipant(
      prices,
      participants,
      selectedCurrency,
      previousParticipants
    );
    return participants;
  }

  
  // if (multiDates && pricesType === EQUAL_PRICE) {
  //   const range = enumerateDaysBetweenDates(
  //     multiDates.startDate,
  //     multiDates.endDate
  //   );
  //   range.forEach(calendarDay => {
  //     const prices = pricesEqual.categories.find(
  //       item => item.day === calendarDay
  //     );
  //     return prices;
  //   });
  //
  //   participants.length = 0;
  //
  //   return _setFixedParticipant(
  //     prices,
  //     participants,
  //     selectedCurrency,
  //     previousParticipants,
  //     range.length
  //   );
  // }

  // if (isMultiDates) {
  //   const range = enumerateDaysBetweenDates(
  //     multiDates.startDate,
  //     multiDates.endDate
  //   );
  //
  //   range.forEach(calendarDay => {
  //     const day = prices.days.find(item => item.day === calendarDay);
  //
  //     _setParticipant(
  //       day,
  //       participants,
  //       selectedCurrency,
  //       previousParticipants
  //     );
  //   });
  //
  //   // fixme: from here
  //   const formattedParticipants = participants.reduce((acc, item) => {
  //     //item.participant === person/senior/adult/children....
  //     const participant = acc.find(
  //       accItem => accItem.participant === item.participant
  //     );
  //     if (participant) {
  //       participant.currencyValue =
  //         Number(participant.currencyValue) + Number(item.currencyValue);
  //       participant.NOK = Number(participant.NOK) + Number(item.NOK);
  //       participant.EUR = Number(participant.EUR) + Number(item.EUR);
  //       participant.USD = Number(participant.USD) + Number(item.USD);
  //     } else {
  //       acc.push(item);
  //     }
  //
  //     return acc;
  //   }, []);
  //
  //   participants.length = 0;
  //   participants.push(...formattedParticipants);
  //   // fixme to here
  //
  //   return participants;
  // }

  // if (isMultiDates) {
  //   const range = enumerateDaysBetweenDates(
  //     multiDates.startDate,
  //     multiDates.endDate
  //   );
  //
  //   range.forEach(calendarDay => {
  //     const day = prices.days.find(item => item.day === calendarDay);
  //
  //     _setParticipant(
  //       day,
  //       participants,
  //       selectedCurrency,
  //       previousParticipants
  //     );
  //   });
  //
  //   // fixme: from here
  //   const formattedParticipants = participants.reduce((acc, item) => {
  //     //item.participant === person/senior/adult/children....
  //     const participant = acc.find(
  //       accItem => accItem.participant === item.participant
  //     );
  //     if (participant) {
  //       participant.currencyValue =
  //         Number(participant.currencyValue) + Number(item.currencyValue);
  //       participant.NOK = Number(participant.NOK) + Number(item.NOK);
  //       participant.EUR = Number(participant.EUR) + Number(item.EUR);
  //       participant.USD = Number(participant.USD) + Number(item.USD);
  //     } else {
  //       acc.push(item);
  //     }
  //
  //     return acc;
  //   }, []);
  //
  //   participants.length = 0;
  //   participants.push(...formattedParticipants);
  //   // fixme to here
  //
  //   return participants;
  // }

  if (pricesType === DAILY_PRICE) {
    const day = prices.days.find(
      item => item.day === moment(startingDate).format('ddd')
    );
    _setParticipant(day, participants, selectedCurrency, previousParticipants);
  } else if (pricesType === DAILY_TIME_PRICE) {
    const day = prices.daysArray.find(item =>
      item.days.includes(moment(startingDate).format('ddd'))
    );
    _setParticipant(day, participants, selectedCurrency, previousParticipants);
  } else if (pricesType === EQUAL_PRICE) {
    _setParticipant(
      prices,
      participants,
      selectedCurrency,
      previousParticipants
    );
  } else if (pricesType === FIXED_PRICE) {
    const item =
    	scheduleType === 'schedulePassForm'
    ? prices
    : prices && prices?.days
        ? prices.days.find(item =>
            item.days.includes(moment(startingDate).format('ddd'))
          )
        : undefined;

if (item) {
  _setFixedParticipant(
    item,
    participants,
    selectedCurrency,
    previousParticipants,
    
  );
}
  }

  return participants;
};

// function enumerateDaysBetweenDates(startDate, endDate) {
//   let date = [];
//   while (moment(startDate) <= moment(endDate)) {
//     date.push(startDate.format('ddd'));
//     startDate = moment(startDate).add(1, 'days');
//   }
//   return date;
// }

const _useFallbackPricing = (
  activity,
  selectedCurrency,
  startingDate,
  scheduleType,
  previousParticipants,
  pricesType
) => {
  const participants = [];
  

 if (pricesType = activity[DAILY_PRICE]?.days?.length > 0) {
    const day = activity[DAILY_PRICE].days.find(
      item => item.day === moment(startingDate).format('ddd')
    );
    if (day) {
      _setParticipant(day, participants, selectedCurrency, previousParticipants);
    }
  }

  else if (pricesType = activity[EQUAL_PRICE]?.categories?.length > 0) {
    _setParticipant(activity[EQUAL_PRICE], participants, selectedCurrency, previousParticipants);
  }



  else if (pricesType = activity[DAILY_TIME_PRICE]?.daysArray?.length > 0) {
    const day = activity[DAILY_TIME_PRICE].daysArray.find(item =>
      item.days.includes(moment(startingDate).format('ddd'))
    );
    if (day) {
      _setParticipant(day, participants, selectedCurrency, previousParticipants);
    }
  }
 
  else if (pricesType = activity[FIXED_PRICE]) {
    const prices = activity[FIXED_PRICE];
    const item =
      scheduleType === 'schedulePassForm'
        ? prices
        : prices.days?.find(item =>
            item.days.includes(moment(startingDate).format('ddd'))
          ) || prices;

    _setFixedParticipant(item, participants, selectedCurrency, previousParticipants);
  }

 
  return _setPreviousParticipantValue(participants, previousParticipants);
};


const _setParticipant = (
  item,
  participants,
  selectedCurrency,
  previousParticipants
) => {
  if (!item) return;
  item.categories.map(item => {
    participants.push({
      id: `${item.participant}-${selectedCurrency}-${item[selectedCurrency]}`,
      participant: item.participant,
      participants: 0,
      currency: selectedCurrency,
      currencyValue: item[selectedCurrency],
      NOK: item.NOK,
      EUR: item.EUR,
      USD: item.USD
    });
  });

  const updatedParticipants = _setPreviousParticipantValue(
    participants,
    previousParticipants
  );

  participants.length = 0;
  participants.push(...updatedParticipants);
};

const _setFixedParticipant = (
  prices,
  participants,
  currency,
  previousParticipants,
  days
) => {
  if (days) {
    participants.push({
      id: `${currency}-${prices.categories[0][currency]}`,
      participant: prices.categories[0].participant,
      participants: 0,
      currency: currency,
      currencyValue: prices.categories[0][currency],
      NOK: prices.categories[0].NOK * days,
      EUR: prices.categories[0].EUR * days,
      USD: prices.categories[0].USD * days
    });
  } else {
    participants.push({
      id: `${currency}-${prices[currency]}`,
      participant: '',
      participants: 0,
      currency: currency,
      currencyValue: prices[currency],
      NOK: prices.NOK,
      EUR: prices.EUR,
      USD: prices.USD
    });
  }
  const updatedParticipants = _setPreviousParticipantValue(
    participants,
    previousParticipants
  );

  participants.length = 0;
  participants.push(...updatedParticipants);
  return participants;
};

const _setPreviousParticipantValue = (participants, previousParticipants) => {
  return participants.map(item => {
    const theSameParticipant = previousParticipants
      ? previousParticipants.find(
          participant => participant.participant === item.participant
        )
      : false;
    if (theSameParticipant) {
      return {
        ...item,
        participants: theSameParticipant.participants
      };
    }
    return item;
  });
};

export { getParticipants };
